import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommerceEmailsListEntityState} from "../reducers/ecommerce-emails-list.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommerceEmailsListState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceEmailsList.entities[websiteId]);

export const getEcommerceEmailsList = (websiteId: number) => createSelector(getEcommerceEmailsListState(websiteId),
  (state: IEcommerceEmailsListEntityState) => {
    return state?.data ? state.data.filter(email => email?.id !== 'customer_invoice') : [];
  }
);

export const getEcommerceEmailsListLoading = (websiteId: number) => createSelector(getEcommerceEmailsListState(websiteId),
  (state: IEcommerceEmailsListEntityState) => state && state.loading
);

export const getEcommerceEmailsListLoaded = (websiteId: number) => createSelector(getEcommerceEmailsListState(websiteId),
  (state: IEcommerceEmailsListEntityState) => state && state.loaded
);
